<template>
  <div id="app" ref="app">
    <top-navbar v-if="isRouterAlive"/>
    <div class="container-fluid" :style="{ minHeight: containerHeight + 'px', paddingLeft: contentPadding }">
      <div id="top-div" ref="topDiv"/>
      <router-view v-if="isRouterAlive"/>
    </div>
    <footer-block v-if="isRouterAlive" :style="{ paddingLeft: contentPadding }"/>
    <user-sidebar/>
  </div>
</template>

<script>
import TopNavbar from '@/components/common/TopNavbar'
import FooterBlock from '@/components/common/FooterBlock'
import { mapActions, mapGetters } from 'vuex'
import UserSidebar from '@/components/common/UserSidebar'

export default {
  components: { UserSidebar, FooterBlock, TopNavbar },
  computed: {
    ...mapGetters(['busy', 'containerHeight', 'isRouterAlive', 'translation', 'contentPadding']),
    ...mapGetters('auth', ['role']),
    ...mapGetters('clients', ['client'])
  },
  methods: {
    ...mapActions(['setWindowSize'])
  },
  mounted () {
    const obj = this
    obj.setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    })
    window.addEventListener('resize', () => {
      setTimeout(() => {
        obj.setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        })
      }, 100)
    })
  }
}
</script>

<style lang="scss">
@import 'assets/scss/vendors/bootstrap-vue/index';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

#sidebar-footer {
  top: 80px;
}

.nav-link {
  &.active {
    color: #ffffff;
    background-color: #88BD2F;
  }
}

.filter-date {
  right: 0;
}

.static-text {
  background-color: #e9ecef
}

.vdp-datepicker__clear-button {
  position: absolute;
  right: 0.3rem;
  top: 0.5rem;
}

.text-green {
  color: #88BD2F;
}

.btn-success {
  background-color: #88BD2F;

  &:focus {
    background-color: #88BD2F;
  }

  &:hover {
    opacity: 0.8;
    background-color: #88BD2F;
  }
}

#top-div {
  height: 84px;
}

.icon-link {
  color: #88BD2F;

  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
}

.dropdown.my-shadow .dropdown-menu {
  box-shadow: 5px 5px 15px 0 rgba(0,0,0,0.5);
}
</style>
